/**
 * Per-request HTTP timeout constants for multipart upload operations.
 *
 * Shared across classic recorder, live recorder, and file upload flows.
 * The Chrome extension duplicates these values inline (cannot import from App).
 */

/** Short API calls: init, getURL, pause, abort, createSession */
export const TIMEOUT_API_SHORT = 60_000;

/** Pulse heartbeat — fires every 30s, must complete well before the next one */
export const TIMEOUT_PULSE = 25_000;

/** S3 chunk upload or backend fallback upload (5 MB over a slow connection) */
export const TIMEOUT_CHUNK_UPLOAD = 120_000;

/**
 * Finalize operations (server-side processing can take very long).
 * `0` disables the timeout in axios. The backend sends keepalive whitespace
 * every 30 s to prevent Cloudflare's 100 s idle timeout.
 */
export const TIMEOUT_FINALIZE = 0;
